// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1Aycd","errors":"Errors_errors__56YGn"};